import { useContext } from 'react';
import localeContext from '../context/localeContext';
export default function useLocaleContext() {
  const context = useContext(localeContext);
  if (context === undefined) {
    throw new Error('useLocaleContext must be used within a LocaleProvider');
  }
  return context;
}